// extracted by mini-css-extract-plugin
module.exports = {"cartItems":"cart-items_cartItems__3BAay","header":"cart-items_header__3xmwc"};